import React from "react";
import { Card } from "antd";
import PublicHeader from "../Header/PublicHeader";
import Footer from "../Footer";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
  <>
  <PublicHeader />
    <div className=" container mx-auto p-6">
      <div className=" container rounded-lg p-6 text-justify mx-auto" style={{ textWrap: 'pretty' }}>
        <h1 className="text-3xl font-bold mb-4 text-center text-[#0d73b9]">
          Privacy Policy
        </h1>
        <p className="text-gray-600  mb-6">
          The <strong>Association of Professional Career Counsellors of India (APCCI)</strong> 
          is committed to protecting your privacy. This policy outlines how we 
          collect, use, store, and safeguard your personal information when you 
          visit our website or use our services.
        </p>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
          <p className="text-gray-700">
            We may collect the following types of information when you interact with us:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2">
            <li>
              <strong>Personal Information:</strong> Name, email address, phone number, 
              and professional details when you register as a member or subscribe to our services.
            </li>
            <li>
              <strong>Payment Information:</strong> Billing details for membership fees, 
              event registrations, and training programs (processed securely through 
              third-party payment providers).
            </li>
            <li>
              <strong>Usage Data:</strong> Information about how you use our website, 
              including IP addresses, browser type, and access times, collected through 
              cookies and analytics tools.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. How We Use Your Information</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>Process memberships, event registrations, and service requests.</li>
            <li>Provide updates, newsletters, and relevant communications.</li>
            <li>Improve website functionality and user experience.</li>
            <li>Comply with legal and regulatory requirements.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Data Protection & Security</h2>
          <p className="text-gray-700">
            We take appropriate security measures to protect your personal data from 
            unauthorized access, misuse, or disclosure. Our website is equipped with 
            industry-standard security measures, including encryption and secure servers, 
            to ensure the safe handling of your data.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Sharing of Information</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>APCCI does not sell, rent, or trade your personal data.</li>
            <li>
              Your information may be shared with third-party service providers for 
              processing payments and hosting events.
            </li>
            <li>
              Legal authorities, if required by law or in response to a legal request.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Use of Cookies</h2>
          <p className="text-gray-700">
            Our website uses cookies to enhance your browsing experience. You can choose 
            to disable cookies in your browser settings, but some website features may 
            not function properly.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Third-Party Links</h2>
          <p className="text-gray-700">
            Our website may contain links to third-party websites. 
            <span >
              {" "}APCCI is not responsible for the privacy policies or practices of external sites.
            </span>
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Your Rights & Choices</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>You have the right to access, update, or request the deletion of your personal data.</li>
            <li>Opt out of marketing emails at any time by clicking the “unsubscribe” link.</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">8. Changes to This Policy</h2>
          <p className="text-gray-700">
            APCCI reserves the right to update this policy as needed. Changes will be 
            posted on this page, and continued use of our website implies acceptance of 
            the updated policy.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
          <p className="text-gray-700">
            For any queries regarding this policy, please reach out to us at:
          </p>
          <p >Email:<b> dgoffice@apcci.in </b></p>
          <p className="font-semibold">
  Or click to <Link to="/contact-us" className="text-blue-500 underline">Contact us</Link>
</p>
        </div>

        <p className="text-gray-700 text-center mt-6">
          By using our website and services, you agree to the terms outlined in this Privacy Policy.
        </p>

        <p className="text-center font-bold mt-4">
          - Association of Professional Career Counsellors of India (APCCI)
        </p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default PrivacyPolicy;
